
import React from "react";

const WithdrawalBankAccountSection = () => {

    return (
        <div>
            <h2 className='sub-title'>Update payroll liabilities withdrawal bank</h2>
        </div>
    )

}

export default WithdrawalBankAccountSection;